import Button from '@mui/material/Button'
import PropTypes from 'prop-types'
import React from 'react'
import { useTheme } from '../../../../utils/themeContext'
import { getColorsForTheme } from '../../../../global-styles/clientColors'

FilterButton.propTypes = {
  isSelected: PropTypes.bool,
}

FilterButton.defaultProps = {
  isSelected: false,
}

export default function FilterButton({ isSelected, ...otherProps }) {
  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)
  
  return (
    <Button
      color={isSelected ? 'secondary' : 'primary'}
      variant={isSelected ? 'contained' : 'outlined'}
      size="large"
      sx={{
        '&:not(:last-child)': {
          marginRight: '0.75rem',
        },
        ...(isSelected && {
          backgroundColor: themeColors.buttonColor,
          color: currentTheme === 'galpin' ? 'black' : 'white',
          '&:hover': {
            backgroundColor: themeColors.buttonHover,
          },
        }),
        ...(!isSelected && {
          borderColor: themeColors.buttonColor,
          color: themeColors.buttonColor,
          '&:hover': {
            borderColor: themeColors.buttonHover,
            color: themeColors.buttonHover,
          },
        }),
      }}
      {...otherProps}
    />
  )
}
